/**
 * c-10ml-countdown.js
 * 10mlの日 カウントダウン
 * - サーバーサイドで計算済みの ISO 文字列 (data-target) からのカウントダウン
 * - クライアントTZ無関係 (JST固定の絶対時刻)
 * - 残り1時間以内で .is-urgent を付与（CSS側でアラート色化）
 */
(function () {
  'use strict';

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function update(elements) {
    const now = Date.now();
    elements.forEach(function (el) {
      const target = new Date(el.dataset.target).getTime();
      if (isNaN(target)) return;
      const diff = Math.max(0, target - now);
      const days = Math.floor(diff / 86400000);
      const hours = Math.floor((diff % 86400000) / 3600000);
      const mins = Math.floor((diff % 3600000) / 60000);
      const secs = Math.floor((diff % 60000) / 1000);

      const dEl = el.querySelector('[data-d]');
      const hEl = el.querySelector('[data-h]');
      const mEl = el.querySelector('[data-m]');
      const sEl = el.querySelector('[data-s]');

      if (dEl) dEl.textContent = pad(days);
      if (hEl) hEl.textContent = pad(hours);
      if (mEl) mEl.textContent = pad(mins);
      if (sEl) sEl.textContent = pad(secs);

      el.classList.toggle('is-urgent', diff > 0 && diff <= 3600000);
      el.classList.toggle('is-finished', diff <= 0);
    });
  }

  function init() {
    const elements = document.querySelectorAll('.c-10ml-countdown[data-target]');
    if (!elements.length) return;
    update(elements);
    setInterval(function () {
      update(elements);
    }, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/**
 * c-10ml-fade-up
 * IntersectionObserver でスクロール出現アニメーション付与
 */
(function () {
  'use strict';

  function init() {
    // c-10ml-fade-up は CSS animation で実装。JS不要。
    // ここは空関数として残し、将来的なスクロール起点アニメーション拡張用に予約。
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
